import React from 'react';
import Box from 'src/components/ui-kit/box/box';
import styles from './create-account.module.scss';
import Button, { ButtonSize } from '../../../../../components/ui-kit/button/button';
import Link from 'next/link';
import { Listing } from 'src/entities/listing';
import { useTranslation } from 'next-i18next';

export default function ListingsBannerCreateAccount({ listing }: { listing: Listing }): JSX.Element {
  const { t } = useTranslation('components:pages:listings:view:banner-create-account');

  const county = listing?.county.name.split(' ')
    .slice(1)
    .join(' ');

  return (
    <Box className={styles.createaccount}>
      <div className={styles.createaccount_content}>
        <h2 className={styles.createaccount_title}>
          {t('TEXT_BUY_MINERAL_RIGHTS', { county, state: listing?.state.name })}
        </h2>
        <p className={styles.createaccount_text}>
          {t('TEXT_IF_YOU_WANT_TO_BUY', { county, state: listing?.state.name })}
        </p>
      </div>
      <div className={styles.createaccount_content}>
        <h2 className={styles.createaccount_title}>
          {t('TEXT_SELL_MINERAL_RIGHTS', { county, state: listing?.state.name })}
        </h2>
        <p className={styles.createaccount_text}>
          {t('TEXT_IF_YOU_WANT_TO_SELL', { county, state: listing?.state.name })}
        </p>
      </div>
      <div className={styles.createaccount_actions}>
        <Link href='/sign-up'>
          <Button
            size={ButtonSize.LARGE}
            className={styles.createaccount_button}>
            {t('BUTTON_CREATE_BUYER_ACCOUNT')}
          </Button>
        </Link>
        <Link href='/blog/industry-news/free-consultation/'>
          <Button
            size={ButtonSize.LARGE}
            className={styles.createaccount_button}>
            {t('BUTTON_SELL_MINERAL_RIGHTS')}
          </Button>
        </Link>
      </div>
    </Box>
  );
}
